import { render, staticRenderFns } from "./leave-details.vue?vue&type=template&id=1705fe6c&scoped=true&"
import script from "./leave-details.vue?vue&type=script&lang=js&"
export * from "./leave-details.vue?vue&type=script&lang=js&"
import style0 from "./leave-details.vue?vue&type=style&index=0&id=1705fe6c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1705fe6c",
  null
  
)

export default component.exports